module.exports = __webpack_public_path__ + "img/vsHandCream5.2bddf92a.jpg";